import { render, staticRenderFns } from "./SalesGroupOverview.vue?vue&type=template&id=01dfe2c1"
import script from "./SalesGroupOverview.vue?vue&type=script&lang=js"
export * from "./SalesGroupOverview.vue?vue&type=script&lang=js"
import style0 from "./SalesGroupOverview.vue?vue&type=style&index=0&id=01dfe2c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports